<!-- Start Footer Area -->
<footer class="footer-area">
    <div class="container" style="max-width: 90%">
        <div class="row" style="justify-content: space-evenly">
            <!-- <div class="col-lg-2 col-md-2 col-sm-6">
                <div class="single-footer-widget">
                    <div class="logo">
                        <a href="#"><img src="assets/img/Logo.png" alt="image" width="200"></a>

                    </div>
                </div>
            </div> -->

            <div class="col-lg-2 col-md-2 col-sm-6">
                <div class="single-footer-widget">
                    <h3>關於</h3>

                    <ul class="footer-services-list">
                        <li><a href="/about">關於碩達</a></li>
                        <li><a href="/contact">聯絡我們</a></li>
                        <li><a href="/downloads">下載專區</a></li>
                        <li><a href="/join-us">加入我們</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-6">
                <div class="single-footer-widget">
                    <h3>永續專區</h3>

                    <ul class="footer-services-list">
                        <li><a href="/esg/environmental">E環境保護</a></li>
                        <li><a href="/esg/social">S社會參與</a></li>
                        <li><a href="/esg/governance">G公司治理</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-6">
                <div class="single-footer-widget">
                    <h3>服務內容</h3>

                    <ul class="footer-contact-list">
                        <li>
                            <a href="/service-details?info=se1"
                                >SAP 企業流程改造</a
                            >
                        </li>
                        <li>
                            <a href="/service-details?info=se2"
                                >軟體定義資訊中心</a
                            >
                        </li>
                        <li>
                            <a href="/service-details?info=se3">企業混合雲</a>
                        </li>
                        <li>
                            <a href="/service-details?info=se4">資訊專案服務</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-2 col-sm-6">
                <div class="single-footer-widget">
                    <h3>解決方案</h3>

                    <ul class="quick-links-list">
                        <li>
                            <a href="/solution-details?info=so1"
                                >企業資源規劃</a
                            >
                        </li>
                        <li>
                            <a href="/solution-details?info=so2"
                                >商業智慧與人工智慧</a
                            >
                        </li>
                        <li>
                            <a href="/solution-details?info=so3"
                                >顧客管理與體驗</a
                            >
                        </li>
                        <li>
                            <a href="/solution-details?info=so4"
                                >企業防疫營運不中斷戰術</a
                            >
                        </li>
                        <!-- <li><a href="/solution-details?info=資料庫與資料管理DB & DW">資料庫與資料管理</a></li> -->
                        <!-- <li><a href="/coming-soon">資料庫與資料管理</a></li> -->
                        <li><a href="/NCour">N-Cour 永續淨零平台</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-2 col-sm-6">
                <div class="single-footer-widget">
                    <h3>碩達系統</h3>

                    <ul class="footer-contact-list">
                        <li>
                            <span>地址： </span
                            ><a href="https://goo.gl/maps/upBxbrUy1S6DNL7f8"
                                >台北市大安區羅斯福路三段37號7樓</a
                            >
                        </li>
                        <li>
                            <span>Email： </span>
                            <a href="mailto:sales@solarix.com.tw"
                                >sales@solarix.com.tw</a
                            >
                        </li>
                        <li>
                            <span>電話： </span>
                            <a href="tel:02-23625368">02-23625368</a>
                        </li>
                        <li>
                            <span>傳真： </span>
                            <a href="tel:02-23625560">02-23625560</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="copyright-area">
        <div class="container" style="max-width: 90%">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <p>
                        碩達系統版權所有 &copy; Solarix System Inc. All Rights
                        Reserved.
                    </p>
                </div>

                <!-- <div class="col-lg-6 col-md-6 col-sm-6">
                    <ul>
                        <li><a href="#">Privacy Policy</a></li>
                        <li><a href="#">Terms & Conditions</a></li>
                    </ul>
                </div> -->
            </div>
        </div>
    </div>

    <!-- <div class="circle-map"><img src="assets/img/circle-map.png" alt="image"></div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div> -->
</footer>
<!-- End Footer Area -->
<div class="go-top">
    <i class="fas fa-arrow-up"></i><i class="fas fa-arrow-up"></i>
</div>
